import axios from "axios";
import appconfig from "../../../AppConfig";
import { debug } from "../../../common/utils";
import { PictureFlag } from "../../../models";
import { UPDATE_PICTURE_FLAG } from "../pictures.actions";

export const updatePictureFlagApi = async (
  dispatch: any,
  pictureId: number,
  flag: PictureFlag,
  value: boolean
) => {
  const url = `products/updatePictureFlag/${pictureId}/${flag}/${value}`;
  const config = {
    baseURL: appconfig.baseURL,
  };

  await axios
    .post(url, null, config)
    .then((response) => {
      debug("!!! API - updatePictureFlagApi !!!");

      if (response && response.data) {
        dispatch({
          type: UPDATE_PICTURE_FLAG,
          pictureId,
          flag,
          value,
        });
      }

      debug(response);
    })
    .catch((err) => {
      console.log(err);
    });
};
